// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaM = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M4 12a8 8 0 1116 0 8 8 0 01-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M8.416 8.404c.014.812.028 1.974.028 3.36V17H6.75V6.948h2.744L11.3 12.31c.164.482.374 1.156.576 1.803.091.294.181.581.264.843h.028c.197-.563.439-1.303.644-1.932.1-.309.192-.59.266-.812l1.806-5.264h2.674V17h-1.722v-5.096c0-.568.012-1.275.023-1.935.01-.576.019-1.116.019-1.495h-.042c-.154.504-.616 1.918-1.078 3.318L12.994 17h-1.736l-2.114-6.258c-.223-.67-.372-1.212-.508-1.705a44 44 0 00-.178-.633z"
    />
  );
export default SvgIconAlphaM;
